<template>
<!--  let nota = avaliacao.avaliacao_resumo?.nota ?? "Sem nota"-->
<!--  let obs = avaliacao.avaliacao_resumo?.observacoes ?? "Sem observações"-->

<!--  obs = obs.replace(/\n/g, '<br>')-->
<!--  let html = "<span><b>Avaliador:</b> " + avaliacao.avaliador.name + "</span> </br>"-->
<!--  html += "<span><b>Situação:</b> " + avaliacao.situacao_avaliacao_resumo + "</span> </br>"-->
<!--  html += "<span><b>Nota:</b> " + nota + "</span> </br>"-->
<!--  html += "<span><b>Últimas observações:</b> " + obs + "</span>"-->
<!--  html += "<hr />"-->
<!--  html += ""-->
  <div v-if="projeto">
    <div class="row">
      <div class="col-12">
        <h2>Avaliação do Projeto</h2>

        <p><b>Avaliador: </b> {{ projeto.avaliacao.avaliador.name }}</p>
        <p><b>Situação: </b> {{ projeto.avaliacao.situacao_avaliacao_resumo }}</p>
        <p><b>Nota: </b> {{ projeto.avaliacao.avaliacao_resumo?.nota ?? "Sem nota" }}</p>
        <p><b>Últimas observações: </b> {{ projeto.avaliacao.avaliacao_resumo?.observacoes ?? "Sem observações" }}</p>
      </div>
    </div>

    <div class="row mt-5">
      <h2>Avaliação do Aplicativo</h2>
      <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
        <thead>
          <tr class="fw-bold fs-6 text-muted">
            <th>Avaliador</th>
            <th>Categoria</th>
            <th>Poster</th>
            <th>Exp. do Trabalho</th>
            <th>Terceira Nota</th>
            <th>Ações</th>
          </tr>
        </thead>

        <tbody>
          <tr class="odd" v-for="item in items">
            <td class="fs-7">
              {{ item.avaliador }}
            </td>
            <td class="fs-7">
              {{ item.categoria }}
            </td>
            <td class="fs-7">
              <span v-if="!trocarNota.includes(item.id)">
                {{ item.poster }}
              </span>

              <input type="number"
                     v-else
                     v-model.number="item.poster"
                     pattern="\d*"
                     @change="verifyMaxMin(0, 10, 'poster')"
                     style="width: 50%"
                     class="border border-gray-300 text-gray-900 sm:text-sm rounded-lg p-2.5"
              >
            </td>
            <td class="fs-7">
              <span v-if="!trocarNota.includes(item.id)">
                {{ item.exposicao }}
              </span>

              <input type="number"
                     v-else
                     v-model.number="item.exposicao"
                     pattern="\d*"
                     @change="verifyMaxMin(0, 25, 'exposicao')"
                     style="width: 50%"
                     class="border border-gray-300 text-gray-900 sm:text-sm rounded-lg p-2.5"
              >
            </td>
            <td class="fs-7">
              <span v-if="!trocarNota.includes(item.id)">
                {{ item.terceira }}
              </span>

              <input type="number"
                     v-else
                     v-model.number="item.terceira"
                     pattern="\d*"
                     @change="verifyMaxMin(0, 30, 'terceira')"
                     style="width: 50%"
                     class="border border-gray-300 text-gray-900 sm:text-sm rounded-lg p-2.5"
              >
            </td>

            <td class="fs-7">
              <a href="#" v-if="!trocarNota.includes(item.id) && can('ADM')" @click="changeNota(item.id)"
                 class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
                 data-bs-toggle="tooltip"
                 data-bs-trigger="hover"
                 title="Alterar nota">
                <i class="fa fa-edit"></i>
              </a>

              <a href="#" v-if="trocarNota.includes(item.id)" @click="salvarNota(item)"
                 class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
                 data-bs-toggle="tooltip"
                 data-bs-trigger="hover"
                 title="Salvar alterações">
                <i class="fa fa-save"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else class="d-flex flex-column">
    <h1>Carregando projeto...</h1>
  </div>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import FormGroup from "@forms/FormGroup";
import FormBody from "@forms/FormBody";
import axios from "axios";
import {success} from "../../Settings/toastr";

export default {
  props: ['projetoId'],
  components: {
    FormGroup,
    FormBody
  },
  data: _ => ({
    projeto: null,
    items: [],
    trocarNota: [],
    loading: false,
  }),

  async created() {
    this.emitter.emit('loading-modal', true)

    //Carrega as informações atualizadas do projeto
    await axios.get(this.route('app.projetos.busca-projeto', {id: this.projetoId})).then(result => {
      this.emitter.emit('loading-modal', false)
      this.projeto = result.data
    })

    this.parseItems()
  },

  mounted() {
    $(this.$refs.select2).select2({
      dropdownParent: '#appModal'
    })
  },
  methods: {
    parseItems () {
      this.items = this.projeto.avaliadores_mesas.map(mesa => ({
        avaliador: mesa.avaliador,
        avaliador_id: mesa.Avaliador_ID,
        id: mesa.id,
        categoria: this.projeto.categoria.nome,
        poster: mesa.notas ? mesa.notas.poster : 'Não avaliado',
        exposicao: mesa.notas ? mesa.notas.exposicao : 'Não avaliado',
        terceira: mesa.notas ? mesa.notas.terceira : 'Não avaliado'
      }))
    },
    changeNota (id) {
      this.trocarNota.push(id)
    },

    async salvarNota(item) {
      this.emitter.emit('loading-modal', true)

      //Carrega as informações atualizadas do projeto
      await axios.post(this.route('app.projetos.edita-nota-mesa', {id: this.projeto.id}), item).then(result => {
        delete this.trocarNota[this.trocarNota.findIndex(n => n === item.id)]

        this.emitter.emit('loading-modal', false)
      })
    },

    verifyMaxMin (index, max, nota) {
      let value = this.items[index][nota]

      if (value < 0) {
        this.items[index][nota] = 0
      }

      if (value > max) {
        this.items[index][nota] = max
      }
    },
  },

  computed: {

  }
}
</script>
